import { render } from "./User-password.vue?vue&type=template&id=585a1ae4"
import script from "./User-password.vue?vue&type=script&lang=js"
export * from "./User-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__